import type { V2CreateAdminUserInput } from '@idc-forms/schemas/api-v2/admin-users'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateUserV2Mutation } from '../hooks/use-user-v2-mutations'
import { UserV2Form } from './user-v2-form'

type UserV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo usuario" (v2) dentro del side panel: el mismo UserV2Form que la edición. */
export function UserV2CreatePanel({ onDone }: UserV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateUserV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: V2CreateAdminUserInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <UserV2Form
      submitLabel="Crear usuario"
      pending={createMutation.isPending}
      isCreate
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
